<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header *ngIf="contentHeader" [contentHeader]="contentHeader"></app-content-header>
    <section class="row">
      <div class="col-xl-3 mb-2 mb-md-0" *ngIf="_utilService.isDesktop || _utilService.isTablet">
        <ul class="nav nav-pills flex-column nav-left mb-0">
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'masterdata' ? 'active' : '')" (click)="active_table = 'masterdata'">
              <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "MASTERDATA" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'addresses' ? 'active' : '')" (click)="active_table = 'addresses'">
              <i [data-feather]="'map-pin'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "ADDRESSES" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'informations' ? 'active' : '')" (click)="active_table = 'informations'">
              <i [data-feather]="'info'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "INFORMATIONS" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1" *ngIf="is_my_profile">
            <a [class]="'nav-link d-flex ' + (active_table === 'change_password' ? 'active' : '')" (click)="active_table = 'change_password'">
              <i [data-feather]="'lock'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "CHANGE_PASSWORD" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1" *ngIf="hasCapability('edit_contract') && !is_my_profile">
            <a [class]="'nav-link d-flex ' + (active_table === 'contract' ? 'active' : '')" (click)="active_table = 'contract'">
              <i [data-feather]="'box'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "CONTRACT" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1" *ngIf="currentUser">
            <a [class]="'nav-link d-flex ' + (active_table === 'id_document' ? 'active' : '')" (click)="active_table = 'id_document'">
              <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "ID_DOCUMENTS" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'emergency_contact' ? 'active' : '')" (click)="active_table = 'emergency_contact'">
              <i [data-feather]="'alert-triangle'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "EMERGENCY_CONTACT" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'socials' ? 'active' : '')" (click)="active_table = 'socials'">
              <i [data-feather]="'link'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "SOCIALS" | translate }}</span>
            </a>
          </li>
          <li class="nav-item mb-1" *ngIf="hasCapability('manage_user_note') && !is_my_profile">
            <a [class]="'nav-link d-flex ' + (active_table === 'notes' ? 'active' : '')" (click)="active_table = 'notes'">
              <i [data-feather]="'paperclip'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "NOTES" | translate }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="col-12" *ngIf="_utilService.isMobile">
        <div ngbDropdown>
          <button ngbDropdownToggle type="button" class="btn btn-outline-primary mb-1 w-100">{{ active_table.toUpperCase() | translate }}</button>
          <div ngbDropdownMenu class="w-100">
            <ul class="nav nav-pills flex-column nav-left mb-0">
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'masterdata' ? 'active' : '')" (click)="active_table = 'masterdata'">
                  <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "MASTERDATA" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'addresses' ? 'active' : '')" (click)="active_table = 'addresses'">
                  <i [data-feather]="'map-pin'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "ADDRESSES" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'informations' ? 'active' : '')" (click)="active_table = 'informations'">
                  <i [data-feather]="'info'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "INFORMATIONS" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="is_my_profile" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'change_password' ? 'active' : '')" (click)="active_table = 'change_password'">
                  <i [data-feather]="'lock'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "CHANGE_PASSWORD" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="hasCapability('edit_contract') && !is_my_profile" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'contract' ? 'active' : '')" (click)="active_table = 'contract'">
                  <i [data-feather]="'box'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "CONTRACT" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="currentUser" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'id_document' ? 'active' : '')" (click)="active_table = 'id_document'">
                  <i [data-feather]="'user'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "ID_DOCUMENTS" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'emergency_contact' ? 'active' : '')" (click)="active_table = 'emergency_contact'">
                  <i [data-feather]="'alert-triangle'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "EMERGENCY_CONTACT" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'socials' ? 'active' : '')" (click)="active_table = 'socials'">
                  <i [data-feather]="'link'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "SOCIALS" | translate }}</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="hasCapability('manage_user_note') && !is_my_profile" ngbDropdownItem>
                <a [class]="'nav-link d-flex ' + (active_table === 'notes' ? 'active' : '')" (click)="active_table = 'notes'">
                  <i [data-feather]="'paperclip'" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{ "NOTES" | translate }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-9" *ngIf="currentUser">
        <!-- contract -->
        <app-user-form-contract [currentUser]="currentUser" *ngIf="active_table === 'contract'"></app-user-form-contract>
        <div class="card" *ngIf="active_table !== 'contract'">
          <div class="card-header">
            <h3 class="card-title" *ngIf="active_table === 'masterdata'">{{ "MASTERDATA" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'addresses'">{{ "RESIDENCE_ADDRESS" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'informations'">{{ "PRIVATE_DATA" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'emergency_contact'">{{ "EMERGENCY_CONTACT" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'id_document'">{{ "ID_DOCUMENT" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'socials'">{{ "SOCIAL_LINKS" | translate }}</h3>
            <h3 class="card-title" *ngIf="active_table === 'change_password'">{{ "CHANGE_PASSWORD" | translate }}</h3>
          </div>
          <!-- masterdata -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'masterdata'">
            <div class="row">
              <div [ngClass.xl]="'col-12 form-group media'" [ngClass.md]="'col-12 form-group media'" [ngClass.sm]="'d-flex flex-column'">
                <a href="javascript:void(0);" (click)="file.click()" [ngClass.xl]="'mr-25'" [ngClass.md]="'mr-25'" [ngClass.sm]="'text-center'">
                  <img *ngIf="avatarImage" [src]="avatarImage" class="rounded mr-50 cover" alt="profile image" height="150" width="150" />
                  <img *ngIf="!avatarImage" src="/assets/images/placeholder-avatar.png" class="rounded mr-50" alt="profile image" height="150" width="150" />
                </a>
                <!-- upload and reset button -->
                <div [ngClass.xl]="'media-body mt-75 ml-1 pt-2'" [ngClass.md]="'media-body mt-75 ml-1 pt-2'" [ngClass.sm]="'media-body col-12'">
                  <button (click)="file.click()" type="button" class="btn btn-md btn-primary" [ngClass.xl]="'mb-75 mr-75'" [ngClass.md]="'mb-75 mr-75'" rippleEffect>{{ "INSERT.UPLOAD_FILE" | translate }}</button>
                  <input type="file" #file id="account-upload" hidden accept="image/*" (change)="handlerChangeFileInput($event, 'avatar')" />
                  <p [ngClass.sm]="'text-center'">{{ "MESSAGES.AVATAR_UPLOAD_INFO" | translate }}</p>
                </div>
                <!--/ upload and reset button -->
              </div>
              <div class="form-group col-xl-5 col-md-6 col-12" *ngIf="hasCapability('edit_others_name')">
                <label for="firstname">{{ "FIRSTNAME" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="firstname" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" formControlName="firstname" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.firstname.errors?.required">{{ "ERRORS.FIELD_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-xl-5 col-md-6 col-12" *ngIf="hasCapability('edit_others_name')">
                <label for="lastname">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="lastname" class="form-control {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" formControlName="lastname" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.lastname.errors?.required">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>

              <div class="form-group col-xl-5 col-md-6 col-12" *ngIf="!hasCapability('edit_others_name')">
                <label>{{ "FIRSTNAME" | translate }}</label>
                <input type="text" class="form-control" [value]="currentUser.firstname" readonly />
              </div>
              <div class="form-group col-xl-5 col-md-6 col-12" *ngIf="!hasCapability('edit_others_name')">
                <label for="lastname">{{ "LASTNAME" | translate }}</label>
                <input type="text" class="form-control" [value]="currentUser.lastname" readonly />
              </div>

              <div class="form-group col-xl-2 col-md-6 col-12">
                <label for="sex">{{ "GENDER" | translate }}</label>
                <select name="sex" id="sex" class="form-control {{ fieldHasErrors('sex') ? 'is-invalid' : '' }}" formControlName="sex">
                  <option value="m">{{ "MALE" | translate }}</option>
                  <option value="f">{{ "FEMALE" | translate }}</option>
                  <option value="o">{{ "OTHER" | translate }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.sex.errors?.required">{{ "ERRRORS.INSERT_SEX" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="birthday">{{ "BIRTHDAY" | translate }}</label>
                <input type="date" id="birthday" [max]="min_birthdate" class="form-control {{ fieldHasErrors('birthday') ? 'is-invalid' : '' }}" formControlName="birthday" />
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="hasCapability('edit_others_email')">
                <label for="email">{{ "USER_OFFICE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="email" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" (change)="handlerChangeOfficeEmail($event)" formControlName="email" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.email.errors?.required">{{ "ERRORS.INSERT_OFFICE_EMAIL" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.email?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" [ngClass.xl]="'pt-2 mt-05 mb-0'" [ngClass.md]="'pt-2 mt-05 mb-0'" *ngIf="hasCapability('send_welcome_email')">
                <div class="d-flex align-items-center">
                  <label for="sendWelcomeEmail" class="mr-075 mb-0">{{ "SEND_WELCOME_EMAIL" | translate }}</label>
                  <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
                    <input id="sendWelcomeEmail" type="checkbox" checked class="custom-control-input" formControlName="send_welcome_email" />
                    <label class="custom-control-label" for="sendWelcomeEmail"></label>
                  </div>
                </div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!hasCapability('edit_others_email')">
                <label for="email">{{ "USER_OFFICE_EMAIL" | translate }}</label>
                <input type="text" class="form-control" [value]="currentUser.email" readonly />
              </div>
            </div>
          </div>
          <!-- addresses -->
          <div class="card-body" *ngIf="active_table === 'addresses'">
            <div class="row" [formGroup]="addressResidence_FormGroup">
              <div class="form-group col-xl-8 col-md-6 col-12">
                <label for="address_street">{{ "ADDRESS_STREET" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_street"
                  [placeholder]="'ADDRESS_STREET_PLACEHOLDER' | translate"
                  class="form-control {{ addressResidence_FormGroup.controls.street.errors ? 'is-invalid' : '' }}"
                  formControlName="street"
                  (change)="isCopingResidence = false"
                />
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.street.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
              </div>
              <div class="col-xl-4 col-md-6 col-12 form-group" *ngIf="addressResidence_FormGroup.value.external">
                <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="country"
                  [items]="nationsWithCodes"
                  bindLabel="name"
                  bindValue="code"
                  [clearable]="false"
                  (change)="isCopingResidence = false"
                  formControlName="country"
                  [ngClass]="addressResidence_FormGroup.controls.country.errors ? 'is-invalid' : ''"
                ></ng-select>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="address_residence_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_residence_zipcode"
                  [placeholder]="'ADDRESS_ZIPCODE_PLACEHOLDER' | translate"
                  class="form-control"
                  formControlName="zipcode"
                  [class]="'form-control ' + (addressResidence_FormGroup.controls.zipcode.errors ? 'is-invalid' : '')"
                  pattern="[0-9]+"
                  (change)="isCopingResidence = false"
                />
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.zipcode.errors?.required">{{ "ADDRESS_ZIPCODE_REQUIRED" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls?.zipcode?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls?.zipcode?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls?.zipcode?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="address_residence_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_residence_city"
                  [items]="_citiesService.list"
                  formControlName="city"
                  [ngClass]="addressResidence_FormGroup.controls.city.errors ? 'is-invalid' : ''"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="setAutoProvince('Residence'); isCopingResidence = false"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.city.errors?.required">{{ "ADDRESS_CITY_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!addressResidence_FormGroup.value.external">
                <label for="address_residence_province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_residence_province"
                  formControlName="province"
                  [class]="addressResidence_FormGroup.controls.province.errors ? 'is-invalid' : ''"
                  [items]="_citiesService.list"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  (change)="isCopingResidence = false"
                  [virtualScroll]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressResidence_FormGroup.controls.province.errors?.required">{{ "ADDRESS_PROVINCE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12 d-flex align-items-center">
                <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
                <div class="custom-control custom-control-primary custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitchExternal" formControlName="external" (change)="manageExternalSiteResidence()" />
                  <label class="custom-control-label" for="customSwitchExternal"> </label>
                </div>
              </div>
            </div>
            <div class="row mt-3 border-top pt-2" [formGroup]="addressShipping_FormGroup">
              <h4 class="col-xl-6 col-md-6 col-12 mb-1">{{ "SHIPPING_ADDRESS" | translate }}</h4>
              <div class="form-group col-xl-6 col-md-6 col-12 pr-0">
                <div
                  class="d-flex justify-content-end"
                  *ngIf="
                    (addressResidence_FormGroup.value.street && addressResidence_FormGroup.value.zipcode && addressResidence_FormGroup.value.city && addressResidence_FormGroup.value.province) ||
                    (addressResidence_FormGroup.value.street && addressResidence_FormGroup.value.external)
                  "
                >
                  <small class="mr-1 mt-025">{{ "ADDRESS_SAME_RESIDENCE" | translate }}</small>
                  <div class="custom-control custom-control-primary custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="isCopingResidence" [ngModelOptions]="{ standalone: true }" id="copyResidence" (click)="copyResidence()" />
                    <label class="custom-control-label" for="copyResidence"> </label>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6 col-xl-{{ is_my_profile ? '8' : '6' }} col-12">
                <label for="address_living_street">{{ "ADDRESS_STREET" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_living_street"
                  (change)="isCopingResidence = false"
                  [placeholder]="'ADDRESS_STREET_PLACEHOLDER' | translate"
                  formControlName="street"
                  [class]="'form-control ' + (addressShipping_FormGroup.controls.street.errors ? 'is-invalid' : '')"
                />
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls.street.errors?.required">{{ "ADDRESS_STREET_REQUIRED" | translate }}</div>
              </div>
              <div class="col-xl-{{ is_my_profile ? '4' : '6' }} col-md-6 col-12 form-group" *ngIf="addressShipping_FormGroup.value.external">
                <label for="country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="country"
                  [items]="nationsWithCodes"
                  bindLabel="name"
                  bindValue="code"
                  (change)="isCopingResidence = false"
                  [clearable]="false"
                  formControlName="country"
                  [ngClass]="addressShipping_FormGroup.controls.country.errors ? 'is-invalid' : ''"
                ></ng-select>
              </div>
              <div class="form-group col-md-6 col-xl-{{ is_my_profile ? '4' : '2' }} col-12" *ngIf="!addressShipping_FormGroup.value.external">
                <label for="address_living_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="address_living_zipcode"
                  [placeholder]="'ADDRESS_ZIPCODE_PLACEHOLDER' | translate"
                  class="form-control"
                  (change)="isCopingResidence = false"
                  formControlName="zipcode"
                  [class]="'form-control ' + (addressShipping_FormGroup.controls.zipcode.errors ? 'is-invalid' : '')"
                  pattern="[0-9]+"
                />
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls.zipcode.errors?.required">{{ "ADDRESS_ZIPCODE_REQUIRED" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls?.zipcode?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls?.zipcode?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls?.zipcode?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!is_my_profile">
                <div class="d-flex justify-content-between align-items-center" [ngbTooltip]="'KM_EXPLICATION_CALCULATE' | translate">
                  <label for="address_living_distance">{{ "DISTANCE_FROM_US" | translate }}</label>
                  <i class="mb-025" [data-feather]="'info'" size="14"></i>
                </div>
                <input
                  type="number"
                  id="address_living_distance"
                  placeholder="100"
                  class="form-control"
                  formControlName="distance_from_us"
                  [class]="'form-control ' + (addressShipping_FormGroup.controls.distance_from_us.errors ? 'is-invalid' : '')"
                />
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls.distance_from_us.errors?.required">{{ "ADDRESS_DISTANCE_REQUIRED" | translate }}</div>
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls.distance_from_us.errors?.max">{{ "ADDRESS_DISTANCE_MAX" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!addressShipping_FormGroup.value.external">
                <label for="address_living_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_living_city"
                  [items]="_citiesService.list"
                  formControlName="city"
                  [class]="addressShipping_FormGroup.controls.city.errors ? 'is-invalid' : ''"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="setAutoProvince('Shipping'); isCopingResidence = false"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls.city.errors?.required">{{ "ADDRESS_CITY_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!addressShipping_FormGroup.value.external">
                <label for="address_living_province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="address_living_province"
                  formControlName="province"
                  [class]="addressShipping_FormGroup.controls.province.errors ? 'is-invalid' : ''"
                  [items]="_citiesService.list"
                  [closeOnSelect]="true"
                  (change)="isCopingResidence = false"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="addressShipping_FormGroup.controls.province.errors?.required">{{ "ADDRESS_PROVINCE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12 d-flex align-items-center">
                <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
                <div class="custom-control custom-control-primary custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitchExternalLiving" formControlName="external" (change)="manageExternalSiteLiving()" />
                  <label class="custom-control-label" for="customSwitchExternalLiving"> </label>
                </div>
              </div>
            </div>
          </div>
          <!-- change password -->
          <div class="card-body" [formGroup]="pwdFormGroup" *ngIf="active_table === 'change_password'">
            <div class="row">
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="old-password">{{ "OLD_PASSWORD" | translate }}</label>
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    [type]="oldPasswordType ? 'text' : 'password'"
                    id="old-password"
                    autocomplete="current-password"
                    class="form-control"
                    formControlName="current_password"
                    aria-describedby="old-password"
                    tabindex="1"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer">
                      <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': oldPasswordType, 'icon-eye': !oldPasswordType }" (click)="togglePasswordTextType('old')"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-12"></div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="new-password">{{ "NEW_PASSWORD" | translate }}</label>
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    [type]="newPasswordType ? 'text' : 'password'"
                    id="new-password"
                    autocomplete="new-password"
                    class="form-control"
                    tabindex="2"
                    aria-describedby="new_password"
                    formControlName="new_password"
                    [ngClass]="pwdFormGroup.hasError('weakPassword') ? 'is-invalid' : ''"
                    (change)="pwdFormGroup.hasError('weakPassword') ? removePwdErrors('weakPassword') : true"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer">
                      <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': newPasswordType, 'icon-eye': !newPasswordType }" (click)="togglePasswordTextType('new')"></i>
                    </span>
                  </div>
                </div>
                <p class="text-danger" *ngIf="pwdFormGroup.hasError('weakPassword')">{{ "PASSWORD_WEAK" | translate }}</p>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="confirm-password">{{ "CONFIRM_PASSWORD" | translate }}</label>
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    [type]="confirmPasswordType ? 'text' : 'password'"
                    id="confirm-password"
                    autocomplete="new-password"
                    class="form-control"
                    tabindex="3"
                    aria-describedby="confirm-password"
                    formControlName="confirm_password"
                    (change)="pwdFormGroup.hasError('notSamePwd') ? removePwdErrors('notSamePwd') : true"
                    [ngClass]="pwdFormGroup.hasError('notSamePwd') ? 'is-invalid' : ''"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer">
                      <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': confirmPasswordType, 'icon-eye': !confirmPasswordType }" (click)="togglePasswordTextType('confirm')"></i>
                    </span>
                  </div>
                </div>
                <p class="text-danger" *ngIf="pwdFormGroup.hasError('notSamePwd')">{{ "PASSWORD_MISMATCH" | translate }}</p>
              </div>
            </div>
          </div>
          <!-- informations -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'informations'">
            <div class="row">
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="birth_place">{{ "BIRTH_PLACE" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="birth_place"
                  class="{{ fieldHasErrors('birth_place') ? 'is-invalid' : '' }}"
                  formControlName="birth_place"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_citiesService.list"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.birth_place.errors?.required">{{ "ADDRESS_PROVINCE_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="working_city">{{ "WORKING_CITY" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="working_city"
                  [items]="_citiesService.list"
                  class="{{ fieldHasErrors('working_city') ? 'is-invalid' : '' }}"
                  formControlName="working_city"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="site">{{ "JOB_SITE" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="site"
                  class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
                  formControlName="site"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_jobSiteService.list"
                ></ng-select>
              </div>
              <div class="form-group col-md-6 col-xl-5 col-12">
                <label for="private_phone">{{ "PRIVATE_PHONE" | translate }}<sup class="text-danger">*</sup></label>
                <input type="tel" id="private_phone" maxlength="15" class="form-control {{ fieldHasErrors('private_phone') ? 'is-invalid' : '' }}" formControlName="private_phone" />
              </div>
              <div class="form-group col-md-6 col-xl-7 col-12 pt-2 mt-05 mb-0" *ngIf="is_my_profile">
                <div class="d-flex align-items-center">
                  <label for="setPublicPhone" class="mr-075 mb-0">{{ "MAKE_PUBLIC_MASCULIN" | translate }}</label>
                  <div class="custom-control custom-control-primary custom-switch w-fit">
                    <input id="setPublicPhone" type="checkbox" checked class="custom-control-input" formControlName="set_public_phone" />
                    <label class="custom-control-label" for="setPublicPhone"></label>
                  </div>
                </div>
              </div>
              <div class="form-group col-xl-5 col-md-6 col-12">
                <label for="private_email">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="email" id="private_email" class="form-control {{ fieldHasErrors('private_email') ? 'is-invalid' : '' }}" formControlName="private_email" />
              </div>
              <div class="form-group col-md-6 col-xl-7 col-12 pt-2 mt-05 mb-0" *ngIf="is_my_profile">
                <div class="d-flex align-items-center">
                  <label for="setPublicEmail" class="mr-075 mb-0">{{ "MAKE_PUBLIC_FEMALE" | translate }}</label>
                  <div class="custom-control custom-control-primary custom-switch w-fit">
                    <input id="setPublicEmail" type="checkbox" checked class="custom-control-input" formControlName="set_public_email" />
                    <label class="custom-control-label" for="setPublicEmail"></label>
                  </div>
                </div>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="civil_status">{{ "CIVIL_STATUS" | translate }}</label>
                <ng-select
                  bindValue="name"
                  bindLabel="name"
                  id="civil_status"
                  class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
                  formControlName="civil_status"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_userService.civil_status"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="currentUser.type_code === 'external'">
                <label for="vat_number">{{ "VAT_NUMBER" | translate }}</label>
                <input type="text" id="vat_number" class="form-control {{ fieldHasErrors('vat_number') ? 'is-invalid' : '' }}" formControlName="vat_number" />
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="currentUser.type_code !== 'external'">
                <label for="IBAN">{{ "IBAN" | translate }}</label>
                <input type="text" id="IBAN" class="form-control {{ fieldHasErrors('IBAN') ? 'is-invalid' : '' }}" formControlName="IBAN" />
              </div>
              <div class="form-group col-md-6 col-xl-3 col-12">
                <label for="child_number">{{ "CHILD_NUMBER" | translate }}</label>
                <input type="number" min="0" id="child_number" class="form-control {{ fieldHasErrors('child_number') ? 'is-invalid' : '' }}" formControlName="child_number" (change)="handlerChangeChild()" />
                <input type="hidden" formControlName="has_child" />
              </div>
            </div>
            <div class="row" *ngIf="!is_my_profile">
              <div class="col-12 mt-2">
                <h4>{{ "MANAGEMENT_FIELDS" | translate }}</h4>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="figure">{{ "FIGURE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="figure"
                  class="{{ fieldHasErrors('figure') ? 'is-invalid' : '' }}"
                  formControlName="figure"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_userFigureService.list"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="hasCapability('assign_role')">
                <label for="role">{{ "ROLE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="role"
                  class="{{ fieldHasErrors('role') ? 'is-invalid' : '' }}"
                  formControlName="role"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_roleService.list"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="reference_hr">{{ "HR_REFERENCE" | translate }}</label>
                <ng-select
                  bindValue="hash"
                  bindLabel="name"
                  id="reference_hr"
                  formControlName="reference_hr"
                  class="{{ fieldHasErrors('reference_hr') ? 'is-invalid' : '' }}"
                  [closeOnSelect]="true"
                  [multiple]="false"
                  [searchable]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="hr_list"
                ></ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="badge_number">{{ "BADGE_NUMBER" | translate }}</label>
                <input type="text" maxlength="10" id="badge_number" class="form-control {{ fieldHasErrors('badge_number') ? 'is-invalid' : '' }}" formControlName="badge_number" />
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="_authenticationService.hasCapability('view_others_tfr_amount')">
                <label for="tfr_amount">{{ "TFR_AMOUNT" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="text" formControlName="tfr_amount" id="tfr_amount" (change)="formatTfrAmount()" class="form-control" />
                </div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12 d-flex align-items-center mt-1">
                <div class="custom-control custom-control-success custom-switch w-fit">
                  <input type="checkbox" class="custom-control-input" id="send_onboarding" formControlName="send_onboarding" />
                  <label class="custom-control-label" for="send_onboarding"></label>
                </div>
                <label for="send_onboarding" class="mb-0">{{ "SET_ONBOARDING_FINISHED" | translate }}</label>
              </div>
              <div class="form-group col-xl-3 col-md-6 col-12 d-flex align-items-center mt-1">
                <div class="custom-control custom-control-success custom-switch w-fit">
                  <input type="checkbox" class="custom-control-input" id="need_assets" formControlName="need_assets" />
                  <label class="custom-control-label" for="need_assets"></label>
                </div>
                <label for="need_assets" class="mb-0">{{ "ASSETS" | translate }}</label>
              </div>
              <div class="form-group col-xl-3 col-md-6 col-12 d-flex align-items-center mt-1">
                <div class="custom-control custom-control-success custom-switch w-fit">
                  <input type="checkbox" class="custom-control-input" id="has_welcomebox" formControlName="has_welcomebox" />
                  <label class="custom-control-label" for="has_welcomebox"></label>
                </div>
                <label for="has_welcomebox" class="mb-0">{{ "HAS_WELCOMEBOX" | translate }}</label>
              </div>
            </div>
          </div>
          <!-- emergency contact -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'emergency_contact'">
            <div class="row">
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="emergency_contact_firstname">{{ "FIRSTNAME" | translate }}</label>
                <input type="tel" id="emergency_contact_firstname" class="form-control {{ fieldHasErrors('emergency_contact_firstname') ? 'is-invalid' : '' }}" formControlName="emergency_contact_firstname" />
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="emergency_contact_lastname">{{ "LASTNAME" | translate }}</label>
                <input type="tel" id="emergency_contact_lastname" class="form-control {{ fieldHasErrors('emergency_contact_lastname') ? 'is-invalid' : '' }}" formControlName="emergency_contact_lastname" />
              </div>
              <div class="form-group col-xl-12 col-md-6 col-12">
                <label for="emergency_contact_phone">{{ "PHONE" | translate }}</label>
                <input type="tel" id="emergency_contact_phone" maxlength="15" class="form-control {{ fieldHasErrors('emergency_contact_phone') ? 'is-invalid' : '' }}" formControlName="emergency_contact_phone" />
              </div>
            </div>
          </div>
          <!-- id_document -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'id_document'">
            <div class="row">
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="type_nationality">{{ "TYPE_NATIONALITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select [clearable]="false" (change)="setCountry()" id="type_nationality" [(ngModel)]="type_nationality" [ngModelOptions]="{ standalone: true }">
                  <ng-option value="Italiana">{{ "ITALIAN" | translate }}</ng-option>
                  <ng-option value="UE">UE</ng-option>
                  <ng-option value="Extra Ue">Extra UE</ng-option>
                </ng-select>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="nationality">{{ "NATIONALITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select id="nationality" class="{{ fieldHasErrors('nationality') ? 'is-invalid' : '' }}" formControlName="nationality">
                  <ng-option *ngFor="let nationality of nationalities_list" [value]="nationality">{{ nationality }}</ng-option>
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.nationality.errors?.required">{{ "ERRORS.INSERT_NATIONALITY" | translate }}</div>
              </div>

              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="document_type">{{ "DOCUMENT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="value"
                  bindLabel="name"
                  id="document_type"
                  formControlName="document_type"
                  class="{{ fieldHasErrors('document_type') ? 'is-invalid' : '' }}"
                  [items]="document_id_types"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.document_type.errors?.required">{{ "ERRORS.INSERT_TYPE_DOCUMENT" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="document_number">{{ "DOCUMENT_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="document_number"
                  oninput="this.value = this.value.toUpperCase()"
                  class="form-control {{ fieldHasErrors('document_number') ? 'is-invalid' : '' }}"
                  formControlName="document_number"
                />
                <div class="invalid-feedback" *ngIf="formGroup.controls.document_number.errors?.required">{{ "ERRORS.INSERT_DOCUMENT_NUMBER" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="document_valid_until">{{ "VALID_UNTIL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="date" id="document_valid_until" [min]="today_date" class="form-control {{ fieldHasErrors('document_valid_until') ? 'is-invalid' : '' }}" formControlName="document_valid_until" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.document_valid_until.errors?.required">{{ "ERRORS.INSERT_DATE" | translate }}</div>
              </div>
              <div class="col-xl-6 col-md-6 col-12">
                <fieldset>
                  <label for="document_id">{{ "DOCUMENT_ID" | translate }}<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="document_id" accept="application/pdf, image/jpg, image/png, image/jpeg" (change)="handlerChangeFileInput($event, 'document-id')" required />
                    <label *ngIf="!fileNameDocumentId" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileNameDocumentId && fileNameDocumentId.length > 0" class="custom-file-label">{{ fileNameDocumentId }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="col-xl-6 col-12">
                <label>&nbsp;</label>
                <div *ngIf="currentUser.document_id && currentUser.document_id.document_url">
                  <button (click)="viewDocument(currentUser.document_id.document_url)" class="btn btn-outline-secondary">{{ "VIEW_DOCUMENT" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <h4>{{ "FISCAL_CODE" | translate }}</h4>
              </div>
              <div class="form-group col-xl-4 col-md-6 col-12">
                <label for="fiscal_code">{{ "FISCAL_CODE" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="fiscal_code" class="form-control {{ fieldHasErrors('fiscal_code') ? 'is-invalid' : '' }}" formControlName="fiscal_code" />
              </div>
              <div class="col-xl-4 col-md-6 col-12">
                <fieldset>
                  <label>{{ "FISCAL_CODE" | translate }}<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="file_fiscal_code" accept="application/pdf, image/jpg, image/png" (change)="handlerChangeFileInput($event, 'fiscal-code')" />
                    <label *ngIf="!fileNameFiscalCode" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileNameFiscalCode && fileNameFiscalCode.length > 0" class="custom-file-label">{{ fileNameFiscalCode }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="col-xl-4 col-12">
                <label>&nbsp;</label>
                <div *ngIf="currentUser.document_id && currentUser.document_id.fiscalcode_url">
                  <button (click)="viewDocument(currentUser.document_id.fiscalcode_url)" class="btn btn-outline-secondary">{{ "VIEW_FISCAL_CODE_DOCUMENT" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="type_nationality === 'Extra Ue'">
              <div class="col-12 mt-4">
                <h4>{{ "RESIDENCE_PERMIT" | translate }}</h4>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="document_residence_permit_valid_until">{{ "VALID_UNTIL" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="date"
                  [min]="today_date"
                  id="document_residence_permit_valid_until"
                  formControlName="document_residence_permit_valid_until"
                  class="form-control {{ fieldHasErrors('document_residence_permit_valid_until') ? 'is-invalid' : '' }}"
                />
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="document_residence_permit_number">{{ "RESIDENCE_PERMIT_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="text"
                  id="document_residence_permit_number"
                  formControlName="document_residence_permit_number"
                  class="form-control {{ fieldHasErrors('document_residence_permit_number') ? 'is-invalid' : '' }}"
                />
              </div>
              <div class="col-xl-6 col-md-6 col-12">
                <fieldset>
                  <label>{{ "RESIDENCE_PERMIT" | translate }}<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="file_residence_permit" accept="image/*,application/pdf" (change)="handlerChangeFileInput($event, 'residence-permit')" />
                    <label *ngIf="!fileNamePermit" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileNamePermit && fileNamePermit.length > 0" class="custom-file-label">{{ fileNamePermit }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="col-xl-4 col-md-6 col-12">
                <label>&nbsp;</label>
                <div *ngIf="currentUser.document_id && currentUser.document_id.residence_permit_url">
                  <button (click)="viewDocument(currentUser.document_id.residence_permit_url)" class="btn btn-outline-secondary">{{ "VIEW_PERMIT_URL" | translate }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- socials -->
          <div class="card-body" [formGroup]="formGroup" *ngIf="active_table === 'socials'">
            <p>{{ "ERRORS.ATTENTION_SOCIAL" | translate }}</p>
            <div class="row">
              <div class="form-group col-xl-6 col-md-6 col-12" *ngFor="let social of available_socials">
                <label class="text-capitalize" [for]="'social-link-' + social">{{ social }}</label>
                <div class="input-group input-group-merge" [id]="'social-link-' + social + '-container'">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><span [data-feather]="social"></span></span>
                  </div>
                  <input
                    type="url"
                    [id]="'social-link-' + social"
                    class="form-control"
                    (change)="handlerChangeSocial(social, $event.target)"
                    [placeholder]="'https://www.' + social + '.com/profileID'"
                    [value]="formGroup.get('socials').value[social] || ''"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- note -->
          <div class="card-body" *ngIf="active_table === 'notes'">
            <div class="card-title d-flex justify-content-between align-items-center px-0 mb-1">
              <h4 class="mb-0">{{ "NOTES" | translate }}</h4>
              <button class="btn btn-outline-primary" (click)="modalOpen(noteAdd, null)">{{ "ADD_NOTE" | translate }}</button>
            </div>
            <h4 *ngIf="!currentUser.notes || currentUser.notes.length < 1">{{ "NO_INSERTED_NOTE" | translate }}</h4>
            <section *ngIf="currentUser && currentUser.notes && currentUser.notes.length > 0" class="row">
              <ul class="col-12 list-unstyled my-2">
                <li class="py-1 d-flex justify-content-between flex-sm-row flex-column bg-light-secondary px-1">
                  <div class="flex-basis-10 mr-075 font-weight-bold">{{ "DATE" | translate }}</div>
                  <div class="flex-basis-20 font-weight-bold">{{ "AUTHOR_NAME" | translate }}</div>
                  <div class="flex-basis-70 font-weight-bold">{{ "NOTE" | translate }}</div>
                </li>
                <li *ngFor="let note of currentUser.notes" class="py-1 d-flex justify-content-between flex-sm-row flex-column px-1 border-left border-right border-bottom">
                  <div class="flex-basis-10 mr-075">{{ _utilService.formatDate(note.insert_date) }}</div>
                  <div class="flex-basis-20">{{ note.creator_firstname }} {{ note.creator_lastname }}</div>
                  <div class="flex-basis-60" [innerHTML]="note.note"></div>
                  <div class="flex-basis-10 text-right">
                    <a
                      *ngIf="_authenticationService.hasCapability('edit_user_note') && me.hash == note.creator_hash"
                      (click)="modalOpen(noteEdit, note)"
                      class="text-secondary mr-1"
                      [ngbTooltip]="'EDIT' | translate"
                      placement="top"
                    >
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </a>
                    <a *ngIf="_authenticationService.hasCapability('manage_user_note')" (click)="deleteNote(note)" class="text-danger" [ngbTooltip]="'DELETE' | translate" placement="top">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </a>
                  </div>
                </li>
              </ul>
            </section>
          </div>
          <!-- footer -->
          <div class="card-footer d-flex pt-2" [ngClass.xl]="'align-items-end'" [ngClass.md]="'align-items-end'" [ngClass.sm]="'flex-column'">
            <div [ngClass.xl]="'flex-basis-50'" [ngClass.md]="'flex-basis-50'" [ngClass.sm]="'mb-1'">
              <div id="contract-daily-cost" *ngIf="active_table === 'contract'">
                {{ "TOTAL_SALARY_DAILY" | translate }}
                <strong>&euro; {{ _manageContract.data.total_daily }}</strong>
              </div>
            </div>
              <button type="submit" class="btn btn-primary position-absolute" *ngIf="active_table === 'masterdata' && hasCapability('restore_employee') && currentUser.type_code == 'ex-employee'" (click)="restoreEmployee()">
                  {{ "ALERT.BTN_RESTORE_EMPLOYEE" | translate }}</button>
            <div [ngClass.xl]="'flex-basis-50 text-right'" [ngClass.md]="'flex-basis-100 text-right'" [ngClass.sm]="'d-flex flex-column'">
              <button type="button" class="btn btn-outline-primary" [ngClass.xl]="'mr-1'" [ngClass.md]="'mr-1'" [ngClass.sm]="'mb-1'" *ngIf="isDisabledSave()" (click)="checkEmptyFieldAlert()">
                {{ "VIEW_EMPTY_FIELDS" | translate }}
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="active_table === 'change_password' ? pwdFormGroup.value.new_password.length < 1 && pwdFormGroup.value.new_password !== pwdFormGroup.value.confirm_password : isDisabledSave()"
                (click)="active_table === 'change_password' ? changePassword() : save()"
              >
                {{ "SAVE" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal Add -->
<ng-template #noteAdd let-modal>
  <form (ngSubmit)="addNote(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0" [formGroup]="formGroup">
      <h3>{{ "ADD_NOTE" | translate }}</h3>
      <label for="note">{{ "NOTE" | translate }}<sup class="text-danger">*</sup></label>
      <textarea formControlName="note" name="note" type="text" id="note" class="form-control"></textarea>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect>
        {{ "CANCEL" | translate }}
      </button>
      <button [disabled]="formGroup.value.note.length < 1" type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Add -->

<!-- Modal Add -->
<ng-template #noteEdit let-modal>
  <form (ngSubmit)="editNote(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "EDIT_NOTE" | translate }}</h3>
      <label for="note">{{ "NOTE" | translate }}<sup class="text-danger">*</sup></label>
      <textarea [(ngModel)]="currentNote.note" name="note" type="text" class="form-control"></textarea>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect>
        {{ "CANCEL" | translate }}
      </button>
      <button [disabled]="currentNote && currentNote.note.length < 1" type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "EDIT" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Add -->
